export enum PlaidAccountMetadata {
    INITIAL_SYNC_STATUS = "initialSyncStatus",
    ACCOUNT_CHURN = "accountChurn",
    LAST_PLAID_CURSOR = "lastPlaidCursor",
}

export enum PlaidTransactionMetadata {
    REMOVE_AT = "removeAt",
}

export enum PlaidInitialSyncStatus {
    NOT_STARTED = "NOT_STARTED",
    IN_PROGRESS = "IN_PROGRESS",
    COMPLETE = "COMPLETE",
}

export const PLAID_PAYPAL_INSTITUTION_ID = "ins_22";

interface PlaidMappedAccount {
    financialAccountId: number | null;
    metadata?: object | null;
}

export function isChurnedPlaidMapping(
    metadata: object | null | undefined,
): boolean {
    if (!metadata || Array.isArray(metadata)) {
        return false;
    }

    for (const [key, value] of Object.entries(metadata)) {
        if (key === PlaidAccountMetadata.ACCOUNT_CHURN) {
            return value === true;
        }
    }

    return false;
}

export function omitChurnedMappingsWithActiveSibling<
    T extends PlaidMappedAccount,
>(accounts: readonly T[]): T[] {
    const activeFinancialAccountIds = new Set<number>();

    for (const account of accounts) {
        if (
            account.financialAccountId !== null &&
            !isChurnedPlaidMapping(account.metadata)
        ) {
            activeFinancialAccountIds.add(account.financialAccountId);
        }
    }

    return accounts.filter((account) => {
        if (
            account.financialAccountId === null ||
            !isChurnedPlaidMapping(account.metadata)
        ) {
            return true;
        }

        return !activeFinancialAccountIds.has(account.financialAccountId);
    });
}
